import React from "react";
import { useLocation } from "react-router-dom";

export default function Image() {
  const location = useLocation();
  const imageUrl = location.search.substring(1);
  return <img src={imageUrl} alt="" />;
}
